// extracted by mini-css-extract-plugin
module.exports = {"container":"TextZodiac1_container__2H0s6","text-anal":"TextZodiac1_text-anal__1bwM8"};